export function decompSumFn(flavorComps: reports.FlavorDecompValues[], selector: (v: reports.FlavorDecompValues) => number) {
  return flavorComps.reduce((accu, curr) => accu + selector(curr), 0);
}